export const ChatIcon = ({ size = 18, strokeColor = "#747474", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M3.99973 19L3.06973 18.63C3.00328 18.7972 2.98317 18.9792 3.01151 19.1569C3.03986 19.3346 3.11562 19.5013 3.2308 19.6395C3.34598 19.7777 3.49632 19.8823 3.66597 19.9422C3.83562 20.0022 4.01829 20.0152 4.19473 19.98L3.99973 19ZM8.70573 18.064L9.17973 17.183L8.86273 17.013L8.51073 17.083L8.70573 18.064ZM5.62373 14.917L6.55373 15.287L6.71673 14.873L6.52073 14.474L5.62373 14.917ZM18.9997 12C18.9997 15.246 16.1467 18 12.4697 18V20C17.1107 20 20.9997 16.486 20.9997 12H18.9997ZM5.94073 12C5.94073 8.754 8.79473 6 12.4707 6V4C7.82973 4 3.93973 7.514 3.93973 12H5.94073ZM12.4707 6C16.1467 6 18.9997 8.754 18.9997 12H20.9997C20.9997 7.514 17.1117 4 12.4707 4V6ZM12.4697 18C11.2647 18 10.1427 17.7 9.17973 17.183L8.23173 18.944C9.53505 19.6427 10.9909 20.0056 12.4697 20V18ZM4.19473 19.98L8.90073 19.044L8.51073 17.083L3.80473 18.019L4.19473 19.981V19.98ZM6.52073 14.474C6.14003 13.7048 5.94224 12.8583 5.94073 12H3.93973C3.93973 13.2 4.22173 14.338 4.72573 15.36L6.52073 14.474ZM4.69473 14.547L3.06973 18.631L4.92773 19.369L6.55173 15.286L4.69373 14.547H4.69473Z"
      fill="white"
    />
    <path
      d="M9 13C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13Z"
      fill="white"
    />
    <path
      d="M12.5 13C13.0523 13 13.5 12.5523 13.5 12C13.5 11.4477 13.0523 11 12.5 11C11.9477 11 11.5 11.4477 11.5 12C11.5 12.5523 11.9477 13 12.5 13Z"
      fill="white"
    />
    <path
      d="M16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13Z"
      fill="white"
    />
  </svg>
);
